import BaseComponent from '../base-component/base-component'
import { Nullable } from '../../types/common'

class LocalizationSelector extends BaseComponent {
  inputSelector: string
  formSelector: string
  input: Nullable<HTMLInputElement>
  form: Nullable<HTMLFormElement>

  constructor() {
    super()

    this.inputSelector = `[data-localization-input]`
    this.formSelector = 'form'

    this.input = this.querySelector(this.inputSelector)
    this.form = this.querySelector(this.formSelector)
  }

  connectedCallback(): void {
    this.addEventListener('click', this.handleClick)
  }

  disconnectedCallback(): void {
    this.removeEventListener('click', this.handleClick)
  }

  handleClick = (event: MouseEvent): void => {
    event.preventDefault()

    const target = event.target as HTMLElement

    if (!target.hasAttribute(`data-localization-item`)) {
      return
    }

    if (!this.input || !this.form || !target.dataset.value) {
      return
    }

    this.input.value = target.dataset.value
    this.form.submit()
  }
}

export default LocalizationSelector
